import { BaseModal } from '@src/common/components/BaseModal';
import { Button } from '@src/common/components/button/Button';
import { Checkbox } from '@src/common/components/Checkbox';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { ModalOrderDescription } from '@src/orders/components/modal/ModalOrderDescription';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { useDeleteOrder } from '@src/orders/hooks/useDeleteOrder';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
  order: OrderListing;
}

export const OrderDeletionModal = ({
  open,
  onClose,
  onSuccess,
  onError,
  order,
}: Props) => {
  const { t } = useTranslation();

  const [hasAcceptedDeletion, setHasAcceptedDeletion] = useState(false);
  const { deleteOrder } = useDeleteOrder({
    onSuccess,
    onError,
  });

  const confirmDeleteCurrentOrder = () => {
    deleteOrder(order.id);
  };

  return (
    <BaseModal
      open={open}
      onClose={() => {
        setHasAcceptedDeletion(false);
        onClose();
      }}
      title={t('orderSummary.delete')}
    >
      <ModalOrderDescription
        clientName={order.client.name}
        createdAt={order.createdAt}
        orderDisplayId={order.displayId}
      />
      <Stack width="fit-content">
        <Checkbox
          label={t('orderSummary.acknowledgeCannotCancel')}
          onClick={() => {
            setHasAcceptedDeletion((prev) => !prev);
          }}
        />
      </Stack>
      <Stack direction="row" gap={theme.spacing['5']} justifyContent="flex-end">
        <Button variant="outlined" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          disabled={!hasAcceptedDeletion}
          variant="contained"
          color="error"
          onClick={confirmDeleteCurrentOrder}
        >
          {t('orderSummary.delete')}
        </Button>
      </Stack>
    </BaseModal>
  );
};
